import { useRef } from "react";
import { Typography, Box, IconButton, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";
import MzAlert from "@markaaz/ui/MzAlert";
import MzButton from "@markaaz/ui/MzButton";
import { FileDownloadIcon, UploadIconWhite, UploadIconGray } from "assets/icons";

const sx = {
  uploadButton: {
    maxWidth: "175px"
  },
  inputFile: {
    display: "none"
  },
  fileName: {
    color: "darkBlue.c100",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    height: "28px",
    maxWidth: "fit-content",
    backgroundColor: "blue.c20",
    borderRadius: "4px",
    padding: "4px 8px 4px 8px"
  },
  closeIcon: {
    height: "8px",
    width: "8px",
    color: "darkBlue.c100"
  }
};

export default function FileUpload({
  showFileName,
  disableFileUpload,
  fileLoading,
  fileName,
  showFileAlert,
  onFileSelect,
  onRemove,
  onDownload,
  onAlertClose
}) {
  const fileInputRef = useRef(null);

  function handleUpload() {
    fileInputRef.current.click();
  }

  return (
    <Box>
      <Typography variant="h4">Field Mapping & Test File Validation for Batch</Typography>
      <Box>
        <Typography variant="h6" mt={10} mb={2}>
          Test File Upload
        </Typography>
        <Typography mb={4} variant="body2" maxWidth={750}>
          Browse your files to select and upload a test file to set up field mapping. You may only have one mapping file
          in use, if you would like to change your mapping file please remove the uploaded file and upload a new test
          file to map.
        </Typography>
        {showFileName ? (
          <Box sx={sx.fileName}>
            <Typography variant="body2">
              {fileName?.length > 15 ? `${fileName.substring(0, 15)}...` : fileName}
            </Typography>
            <IconButton onClick={onRemove} sx={sx.closeIcon}>
              <Close />
            </IconButton>
          </Box>
        ) : (
          <MzButton startIcon={<FileDownloadIcon />} onClick={onDownload}>
            <Typography variant="button2">Download CSV Test File Template</Typography>
          </MzButton>
        )}
        <Stack direction="row" gap={10} mt={5} alignItems="center">
          <MzButton
            sx={sx.uploadButton}
            startIcon={disableFileUpload || fileLoading ? <UploadIconGray /> : <UploadIconWhite />}
            variant="contained"
            loading={fileLoading}
            onClick={handleUpload}
            size="large"
            disabled={disableFileUpload}
          >
            Upload a File
          </MzButton>
          <input type="file" accept=".csv" ref={fileInputRef} style={sx.inputFile} onChange={onFileSelect} />

          {showFileAlert.message && (
            <MzAlert
              sx={{ alignItems: "center" }}
              severity={showFileAlert.type === "success" ? "success" : "error"}
              onClose={() => {
                onAlertClose("file");
              }}
            >
              {showFileAlert.message}
            </MzAlert>
          )}
        </Stack>
      </Box>
    </Box>
  );
}
